<template>
  <div class="app-wrap">
    <NuxtRouteAnnouncer />
    <NuxtLayout name="default" v-if="isUserCenterRoute">
      <NuxtPage />
    </NuxtLayout>
    <NuxtPage v-else />
  </div>
</template>
<script setup>
import { computed, onMounted, watch, onBeforeMount } from "vue";
import { useRoute } from "#app";
import { useMainStore } from "@/composables/store";
import { setToken,setIsErpBuyMode,isErpBuyMode } from "@/utils/globalData";
import { useLanguageDetection } from "@/composables/useLanguageDetection";
import config from "@/config/index";

 
const store = useMainStore();
const route = useRoute();
const isUserCenterRoute = computed(() => {
  return route.path === "/user-center" || route.path.startsWith("/user-center/");
});

// 语言检测功能
const { autoSwitchLanguage } = useLanguageDetection();
 
onBeforeMount(() => {
  if (process.client) {
    if (route.query.setJyToken) {
      // 手工直接设置token进到系统
        setToken(route.query.setJyToken);
    }

    if(process.client){
      if (route.query.isTbPurchaseOrderMode) {
        window.localStorage.setItem(config.isTbPurchaseOrderModeKey,"1");
      }else{
        window.localStorage.removeItem(config.isTbPurchaseOrderModeKey);
      }
    }
    console.log(window.location.pathname,'window.location.pathname',route.query.batchBindMallOrder==1|| isErpBuyMode())
    if ( (window.location.pathname=='/' || window.location.pathname=='/product/search' ) && (route.query.batchBindMallOrder==1|| isErpBuyMode())) {
      // 采购模式进到系统
      setIsErpBuyMode(true);
    } 
    
  }
})
onMounted(async () => {
  if (process.client) {
    // 首次访问时自动检测并切换语言
    autoSwitchLanguage();
  }
});

async function changeThemeColor() {
  if (process.client) {
    const { changeTheme } = await import("@/utils/themeColor");
    changeTheme("#f0700c");
  }
}
onBeforeMount(async () => {
  if (process.client) {
    store.initCurrentCurrency();
    changeThemeColor();
    store.getCurrentUserData();
  }
});
if (process.client) {
  watch(
    () => route,
    () => {
      changeThemeColor();
      store.getCurrentUserData();
    },
    { deep: true }
  );
}
</script>
<style>
.app-wrap {
  --el-color-primary-light-0: #F0700C;
  --el-color-primary-light-1: #F27E24;
  --el-color-primary-light-2: #F38D3D;
  --el-color-primary-light-3: #F59B55;
  --el-color-primary-light-4: #F6A96D;
  --el-color-primary-light-5: #F8B886;
  --el-color-primary-light-6: #F9C69E;
  --el-color-primary-light-7: #FBD4B6;
  --el-color-primary-light-8: #FCE2CE;
  --el-color-primary-light-9: #FEF1E7;
  --el-color-primary-dark-0: #D8650B;
  --el-color-primary-dark-1: #C05A0A;
  --el-color-primary-dark-2: #A84E08;
  --el-color-primary: #f0700c;
}

.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}

.layout-enter-active,
.layout-leave-active {
  transition: all 0.4s;
}

.layout-enter-from,
.layout-leave-to {
  filter: grayscale(1);
}

.flex-col {
  display: flex;

}

.flex-row {
  display: flex;

}
</style>
